


































import Vue, { PropType } from "vue";
import { DashboardWidget } from "@/model/data/dashboard/DashboardWidget";
import { WidgetTypesEnum } from "@/model/data/dashboard/WidgetTypesEnum";
import { mapGetters, mapState } from "vuex";
import { RootState } from "@/store";
import { LicenseModuleEnum } from "@/model/data/License/LicenseModuleEnum";
import { LicenseData } from "@/model/data/License/LicenseData";
import { ClientPrivileges } from "@/model/data/authentication/ClientPrivilegesEnum";

export default Vue.extend({
    data() {
        return {
            WidgetTypesEnum,
            availableRefreshTimeout: [
                { value: 0, text: this.$t("common.no") },
                { value: 30, text: this.$tc("common.second", 30, { count: 30 }) },
                { value: 60, text: this.$tc("common.minute", 1, { count: 1 }) },
                { value: 300, text: this.$tc("common.minute", 5, { count: 5 }) },
                { value: 600, text: this.$tc("common.minute", 10, { count: 10 }) },
                { value: 1800, text: this.$tc("common.minute", 30, { count: 30 }) },
                { value: 3600, text: this.$tc("common.hour", 1, { count: 1 }) },
            ],
        };
    },
    props: {
        widget: Object as PropType<DashboardWidget>,
    },
    computed: {
        ...mapState({
            licenseData: (state: RootState) => state.license.licenseModules,
        }),
        ...mapGetters(["authUserHasPrivilege"]),

        availableWidgetTypes() {
            let widgetTypes = [];

            widgetTypes.push({
                text: this.$t("dashboard.widget_types.device_count"),
                value: WidgetTypesEnum.DeviceCount,
                disabled: !(this.licenseData as LicenseData).isAvailable(LicenseModuleEnum.ServiceAndUpdatesManagement),
            });

            widgetTypes.push({
                text: this.$t("dashboard.widget_types.device_summary"),
                value: WidgetTypesEnum.InstallationSummary,
                disabled:
                    !(this.licenseData as LicenseData).isAvailable(LicenseModuleEnum.ServiceAndUpdatesManagement) || !this.authUserHasPrivilege(ClientPrivileges.StatusManagement),
            });

            widgetTypes.push({
                text: this.$t("dashboard.widget_types.device_status"),
                value: WidgetTypesEnum.DeviceStatus,
                disabled:
                    !(this.licenseData as LicenseData).isAvailable(LicenseModuleEnum.ServiceAndUpdatesManagement) || !this.authUserHasPrivilege(ClientPrivileges.StatusManagement),
            });

            widgetTypes.push({
                text: this.$t("dashboard.widget_types.installations_status_changes"),
                value: WidgetTypesEnum.InstallationsStatusChanges,
                disabled:
                    !(this.licenseData as LicenseData).isAvailable(LicenseModuleEnum.ServiceAndUpdatesManagement) || !this.authUserHasPrivilege(ClientPrivileges.StatusManagement),
            });

            widgetTypes.push({
                text: this.$t("dashboard.widget_types.update_status"),
                value: WidgetTypesEnum.UpdateStatus,
                disabled:
                    !(this.licenseData as LicenseData).isAvailable(LicenseModuleEnum.ServiceAndUpdatesManagement) || !this.authUserHasPrivilege(ClientPrivileges.UpdatesManagement),
            });

            widgetTypes.push({
                text: this.$t("dashboard.widget_types.cash_count"),
                value: WidgetTypesEnum.CashCount,
                disabled:
                    !(this.licenseData as LicenseData).isAvailable(LicenseModuleEnum.CashFlowManagement) || !this.authUserHasPrivilege(ClientPrivileges.CashFlowContentMonitoring),
            });

            widgetTypes.push({
                text: this.$t("dashboard.widget_types.cash_distribution"),
                value: WidgetTypesEnum.CashDistribution,
                disabled:
                    !(this.licenseData as LicenseData).isAvailable(LicenseModuleEnum.CashFlowManagement) || !this.authUserHasPrivilege(ClientPrivileges.CashFlowContentMonitoring),
            });

            widgetTypes.push({
                text: this.$t("dashboard.widget_types.transactions"),
                value: WidgetTypesEnum.Transactions,
                disabled:
                    !(this.licenseData as LicenseData).isAvailable(LicenseModuleEnum.CashFlowManagement) ||
                    !this.authUserHasPrivilege(ClientPrivileges.CashFlowTransactionsReporting),
            });

            return widgetTypes;
        },
    },
});
